import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuSubProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";

export const DropdownMenuSub = (props: TDropdownMenuSubProps) => (
  <DropdownMenuPrimitive.Sub {...props} />
);

DropdownMenuSub.displayName = DropdownMenuPrimitive.Sub.displayName;
